import { setComponentMapOverrides } from '@jutro/uiconfig';

import FNOLPLWizard from './FNOLPLWizard';

setComponentMapOverrides(
    {
        FNOLPLWizard: { component: 'FNOLPLWizard' }
    },
    {
        FNOLPLWizard
    }
);

export {
    FNOLPLWizard as default
};
